import type { AnyRoute } from "@tanstack/react-router";

import { createDashboardRoutes } from "./createDashboardRoutes";
import type { AnalyticsAndInsightsRouteDeps } from "./analyticsAndInsightsRouteContext";

export type {
  AnalyticsAndInsightsRouteDeps,
  AnalyticsAndInsightsRouteFactory,
} from "./analyticsAndInsightsRouteContext";

export function createAnalyticsAndInsightsRoutes(
  deps: AnalyticsAndInsightsRouteDeps,
): AnyRoute[] {
  return [...createDashboardRoutes(deps)];
}
